module.exports = __webpack_public_path__ + "img/0Q3A6117_8_9_FoamcoreMatted.4e3de22a.jpg";